module.exports = __webpack_public_path__ + "img/portrait-050.640766a5.jpg";